import { useCreateAdminAccount } from "@/hooks/query-hooks/useAuth";
import { Button, Divider, Flex, Form, Input } from "antd";
import { Helmet } from 'react-helmet-async';
import { AnimatedComponent } from "../common";
import { createAdminAccountRequestSchema } from "@/constants/zod-schemas";

export function AddAdminAccount() {

    const [form] = Form.useForm();

    const { mutate, isMutating } = useCreateAdminAccount();
    const onFinish = (values: CreateAdminAccountRequest) => {
        const payload = createAdminAccountRequestSchema.parse(values);
        mutate(payload, {
            onSuccess: () => {
                form.resetFields();
            },
        })
    }

    return (
        <AnimatedComponent>
            <Helmet>
                <title> အကောင့် အသစ်ထည့်ရန် </title>
            </Helmet>
            <h2
                className="text-2xl font-semibold text-primary-gradient font-poppins "
            >
                Add Admin Account
            </h2>
            <Divider />
            <Form
                layout="vertical"
                form={form}
                onFinish={onFinish}
                className="max-w-lg mx-auto !p-6 rounded shadow"
            >
                <Form.Item
                    name={"name"}
                    label={"Name"}
                    rules={[
                        {
                            required: true,
                            message: "Please input your name!"
                        }
                    ]}
                >
                    <Input
                        size="large"
                    />
                </Form.Item>
                <Form.Item
                    name={"phone"}
                    label={"Mobile Number"}
                    rules={[
                        {
                            required: true,
                            message: "Required!"
                        },
                        {
                            pattern: /^09\d{6,9}$/,
                            message: "Invalid mobile number!"
                        }
                    ]}
                    className=" justify-center"
                >
                    <Input
                        size="large"
                    />
                </Form.Item>
                <Form.Item
                    name={"password"}
                    label={"Password"}
                    rules={[
                        {
                            required: true,
                            message: "Required!"
                        }
                    ]}
                >
                    <Input.Password
                        size="large"
                    />
                </Form.Item>
                <Flex
                    gap={12}
                    justify="end"
                    className="!mt-8"
                >
                    <Button
                        type="text"
                        onClick={() => form.resetFields()}
                        size="large"
                        disabled={isMutating}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="primary"
                        htmlType="submit"
                        size="large"
                        className="bg-primary-gradient"
                        shape="round"
                        loading={isMutating}
                    >
                        Confirm
                    </Button>
                </Flex>
            </Form>
        </AnimatedComponent>
    )
}
